import { render } from "./homeNews.vue?vue&type=template&id=18050fab&scoped=true"
import script from "./homeNews.vue?vue&type=script&lang=js"
export * from "./homeNews.vue?vue&type=script&lang=js"

import "./homeNews.vue?vue&type=style&index=0&id=18050fab&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18050fab"]])

export default __exports__